import {
  DELETE_MEDICAL_EXPENSES,
  GET_MEDICAL_EXPENSES,
  GET_MEDICAL_EXPENSES_LIST,
  POST_MEDICAL_EXPENSES,
  PUT_MEDICAL_EXPENSES,
  COPY_MEDICAL_EXPENSES_FROM_PREVIOUS_YEAR,
} from "../constants/actionTypes";

const defaultState = {
  medicalExpensesArr:[],
  medicalExpenses:{}
};
let data=[]
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_MEDICAL_EXPENSES_LIST:
        return {...state,medicalExpensesArr:[...action.payload]};
      case GET_MEDICAL_EXPENSES:
        return {...state,medicalExpenses:{...action.payload}};
      case POST_MEDICAL_EXPENSES:
        return {...state,medicalExpensesArr:[...state?.medicalExpensesArr,action.payload]};
      case PUT_MEDICAL_EXPENSES:
        data = [...state?.medicalExpensesArr];
        index = data?.findIndex(
          (setting) => setting?.id_customer === action.payload?.id_customer,
        );
        if (index != -1) data[index] = { ...action?.payload };
        return {...state,medicalExpensesArr: [...data]};
      case DELETE_MEDICAL_EXPENSES:
        data = [...state?.medicalExpensesArr];
        const newData = data?.filter(
          (income) => income.id!=action.payload,
        );
        return {...state,medicalExpensesArr: [...newData]};
      case COPY_MEDICAL_EXPENSES_FROM_PREVIOUS_YEAR:
        return {...state,medicalExpensesArr: Array.isArray(action.payload) ? [...action.payload] : []};
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
